export const BeersActionTypes = {
  ADD_BEER: 'ADD_BEER',
  UPDATE_BEER: 'UPDATE_BEER',
  REMOVE_BEER: 'REMOVE_BEER',
  FETCH_BEERS_START: 'FETCH_BEERS_START',
  FETCH_BEERS_SUCCESS: 'FETCH_BEERS_SUCCESS',
  FETCH_BEERS_FAILURE: 'FETCH_BEERS_FAILURE',
};
